import type { PrefillUrlParams } from '@/libs/api/appform/app-form.types.ts'
import { parseDateString } from '@/utils/date-util.ts'
import { cleanupUrlSuffix } from '@/utils/url-util.ts'

type PrefillHandling = {
  beforeAppendTransformation?: (value: unknown) => string
  postAppendHook?: (key: keyof PrefillUrlParams, value: unknown) => void
}

type PrefillHandlingMapping = Record<keyof PrefillUrlParams, PrefillHandling | undefined>

export const useAppFormService = () => {
  const prefillMapping: Partial<PrefillHandlingMapping> = Object.freeze({
    device_class_id: undefined,
    product_id: undefined,
    device_purchase_price: undefined,
    device_purchase_date: {
      beforeAppendTransformation(value) {
        return parseDateString(value as string).format('YYYY-MM-DD')
      }
    },
    partner: undefined,
    sc_sid: undefined,
    prefill: undefined
  })

  function buildPrefillUrl(baseUrl: string, params: Partial<PrefillUrlParams>) {
    const preparedBaseUrl = cleanupUrlSuffix(baseUrl)
    const searchParams = new URLSearchParams()

    Object.entries(prefillMapping).forEach(([keyString, handling]) => {
      const key = keyString as keyof PrefillHandlingMapping
      const value = params[key]

      if (value) {
        const transformedValue = handling?.beforeAppendTransformation?.(value) ?? value
        searchParams.append(key, transformedValue)
        handling?.postAppendHook?.(key, transformedValue)
      }
    })

    if (searchParams && searchParams.size > 0) {
      return `${preparedBaseUrl}/#/?${searchParams.toString()}`
    }
    return baseUrl
  }

  return {
    buildPrefillUrl
  }
}
